import { assign } from 'fsm';
import I18n from 'I18n';
import Raven from 'raven-js';
import { wait } from '../utils';
import { fetchObjectLabels } from './client';
const MAX_RETRY_COUNT = 1;
const RETRY_WAIT_TIME = 100;
export const machine = {
  initial: 'loading',
  states: {
    loading: {
      invoke: {
        src: 'fetchObjectLabels',
        onDone: {
          target: 'idle',
          actions: ['setObjectLabels', 'resetRetryCount']
        },
        onError: [{
          target: 'retryDelay',
          actions: ['incrementRetryCount', 'logError'],
          cond: 'shouldRetry'
        }, {
          target: 'idle',
          actions: ['addLoadingError', 'logError', 'resetRetryCount']
        }]
      },
      tags: ['loading']
    },
    retryDelay: {
      invoke: {
        src: 'waitForRetry',
        onDone: {
          target: 'loading'
        }
      },
      tags: ['loading']
    },
    idle: {}
  },
  actions: {
    addLoadingError: context => {
      var _context$addAlertDang;
      (_context$addAlertDang = context.addAlertDanger) === null || _context$addAlertDang === void 0 || _context$addAlertDang.call(context, {
        message: I18n.text('enrichmentProperties.settings.fetchingError.message'),
        titleText: I18n.text('enrichmentProperties.settings.fetchingError.title')
      });
    },
    incrementRetryCount: assign(context => {
      return {
        retryCount: context.retryCount + 1
      };
    }),
    logError: (_context, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON !== null && responseJSON !== void 0 ? responseJSON : JSON.stringify(event));
    },
    resetRetryCount: assign(() => {
      return {
        retryCount: 0
      };
    }),
    setObjectLabels: assign((_context, event) => {
      return {
        companyLabels: event.data.companyLabels,
        contactLabels: event.data.contactLabels
      };
    })
  },
  guards: {
    shouldRetry: context => context.retryCount < MAX_RETRY_COUNT
  },
  services: {
    fetchObjectLabels,
    waitForRetry: async () => {
      await wait(RETRY_WAIT_TIME);
    }
  }
};